module.exports = __webpack_public_path__ + "static/media/espresso-tests.282e16d8.png";